import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth'
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyDILc26V9aXI4OGo7KHLN4c4ShkSyDTguE",
  authDomain: "school1-fa5a9.firebaseapp.com",
  projectId: "school1-fa5a9",
  storageBucket: "school1-fa5a9.appspot.com",
  messagingSenderId: "559947612746",
  appId: "1:559947612746:web:7a725f609064d13d255cb3",
  measurementId: "G-V5H5NLS4LT"
};

const app = initializeApp(firebaseConfig)
const auth = getAuth(app);
const gprovider = new GoogleAuthProvider();
const fprovider = new FacebookAuthProvider();

let analytics = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log("[Firebase] Analytics initialized successfully:", firebaseConfig.measurementId);
    }
  }).catch((err) => {
    console.warn("[Firebase] Analytics not supported:", err);
  });
}

export const logAnalyticsEvent = (eventName, params = {}) => {
  try {
    if (analytics) {
      logEvent(analytics, eventName, params);
    }
  } catch (err) {
    console.warn("[Firebase] logEvent error:", err);
  }
};

export { app, auth, analytics, gprovider, fprovider, firebaseConfig };